"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var React = __importStar(require("react"));
var material_1 = require("../../styles/material");
var icons_1 = require("../../icons");
exports.Select = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, value = _a.value, options = _a.options, onChange = _a.onChange, multiple = _a.multiple, restProps = __rest(_a, ["label", "placeholder", "value", "options", "onChange", "multiple"]);
    return (React.createElement(core_1.ThemeProvider, { theme: material_1.theme }, multiple ? (React.createElement(exports.SelectMultiple, __assign({ label: label, placeholder: placeholder, value: value, options: options, onChange: onChange, multiple: true }, restProps))) : (React.createElement(exports.SelectSingle, __assign({ label: label, placeholder: placeholder, value: value, options: options, onChange: onChange }, restProps)))));
};
exports.SelectSingle = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, value = _a.value, options = _a.options, onChange = _a.onChange, restProps = __rest(_a, ["label", "placeholder", "value", "options", "onChange"]);
    return (React.createElement(Autocomplete_1.default, __assign({ value: options.find(function (option) { return option.value === value; }), autoHighlight: true, onChange: function (event, value) {
            var _a, _b;
            if (!!onChange)
                onChange((_b = (_a = value) === null || _a === void 0 ? void 0 : _a.value, (_b !== null && _b !== void 0 ? _b : '')));
        }, options: options, getOptionLabel: function (option) { var _a; return (_a = option) === null || _a === void 0 ? void 0 : _a.label; }, getOptionSelected: function (option, value) { var _a, _b; return ((_a = option) === null || _a === void 0 ? void 0 : _a.value) === ((_b = value) === null || _b === void 0 ? void 0 : _b.value); }, renderInput: function (params) { return React.createElement(TextField_1.default, __assign({ label: label, placeholder: placeholder }, params, { fullWidth: true })); }, popupIcon: React.createElement(ExpandMore_1.default, null), closeIcon: React.createElement(Close_1.default, null) }, restProps)));
};
exports.SelectMultiple = function (_a) {
    var _b;
    var label = _a.label, placeholder = _a.placeholder, value = _a.value, options = _a.options, onChange = _a.onChange, restProps = __rest(_a, ["label", "placeholder", "value", "options", "onChange"]);
    return (React.createElement(Autocomplete_1.default, __assign({ multiple: true, disableCloseOnSelect: true, value: (_b = value) === null || _b === void 0 ? void 0 : _b.map(function (v) { return options.find(function (option) { return option.value === v; }); }), onChange: function (event, value) {
            if (!!onChange)
                onChange(value.map(function (_a) {
                    var value = _a.value;
                    return value;
                }));
        }, options: options, getOptionLabel: function (option) { var _a; return (_a = option) === null || _a === void 0 ? void 0 : _a.label; }, getOptionSelected: function (option, value) { var _a, _b; return ((_a = option) === null || _a === void 0 ? void 0 : _a.value) === ((_b = value) === null || _b === void 0 ? void 0 : _b.value); }, renderOption: function (option, _a) {
            var selected = _a.selected;
            var _b;
            return (React.createElement(React.Fragment, null,
                React.createElement(core_1.Checkbox, { icon: icons_1.Unchecked, checkedIcon: icons_1.Checked, checked: selected }), (_b = option) === null || _b === void 0 ? void 0 :
                _b.label));
        }, renderInput: function (params) { return React.createElement(TextField_1.default, __assign({ label: label, placeholder: placeholder }, params, { fullWidth: true })); }, popupIcon: React.createElement(ExpandMore_1.default, null), closeIcon: React.createElement(Close_1.default, null), ChipProps: {
            deleteIcon: icons_1.RemoveTag
        }, classes: { option: 'multiple', inputRoot: 'multiple' } }, restProps)));
};
//# sourceMappingURL=Select.js.map